import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { SapBwCubeDataset } from 'app/model/dataset/sap-bw-cube.dataset';
import { tabularTypeDatasetAdapts, TabularTypeDatasetAdapter } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapBwCubeDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class SapBwCubeDatasetAdapter extends TabularTypeDatasetAdapter<SapBwCubeDataset, Model.DatasetResource> {
    protected async _toResource(dataset: SapBwCubeDataset): Promise<Model.DatasetResource> {
        const resource: Model.DatasetResource = await this._toResourceInternal(dataset, Metamodel.modelFor(SapBwCubeDataset).name);
        if (dataset && resource && resource.properties && resource.properties.typePropertites) {
            delete resource.properties.typePropertites['tableName'];
        }
        if (dataset && resource && resource.properties && resource.properties.typePropertites == null) {
            resource.properties.typePropertites = {};
        }
        return resource;
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: SapBwCubeDataset): Promise<SapBwCubeDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, SapBwCubeDataset.MODEL);
    }
}
